export default __webpack_public_path__ + "static/media/folder.f97eaa15.svg";